<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <hatadialog ref="hatadialog"></hatadialog>
<v-dialog v-model="columnDialog" max-width="900px" scrollable>
  <v-card>
    <v-card-title class="headline">
      Kolon Yönetimi
    </v-card-title>

    <v-divider></v-divider>

    <v-card-text style="max-height: 70vh;">
      <div class="mb-3">
        Görünecek kolonları seç. Sıralamayı burada da değiştirebilirsin.
      </div>

      <draggable
        v-model="headerssatis"
        :options="{ handle: '.column-drag-handle', animation: 150 }"
        @end="saveTableSettings"
      >
        <div
          v-for="col in headerssatis"
          :key="col.value"
          class="column-manager-row"
        >
          <div class="column-manager-left">
            <v-icon small class="column-drag-handle mr-2">drag_indicator</v-icon>

            <v-checkbox
              v-model="col.visible"
              hide-details
              class="ma-0 pa-0"
              @change="saveTableSettings"
            ></v-checkbox>

            <span class="column-manager-title">{{ col.text }}</span>
          </div>

          <div class="column-manager-right">
            <span class="column-manager-key">{{ col.value }}</span>
          </div>
        </div>
      </draggable>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-btn flat color="warning" @click="resetColumns">
        Varsayılana Dön
      </v-btn>

      <v-spacer></v-spacer>

      <v-btn flat color="primary" @click="columnDialog = false">
        Kapat
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 md12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title> {{$t('Transfer-Name-List')}} </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-menu bottom left>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list v-if="PB=='TRY'">
                  <v-list-tile @click="getListExcel()">
                    <v-list-tile-title>Excel {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>

          <v-container fluid>
            <v-form ref="formgunluksatis" v-model="valid" lazy-validation>
              <v-layout row wrap>
                <v-flex pb-3 xs12 sm12 md12>
                  <v-card flat>
                    <v-layout row wrap>
                      <v-flex xs12 sm6 pt-2 md1>
                        <tarihcomp :etiket="$t('Starting-Date')" :detaygizle="false"
                          :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"
                          v-bind:value="KayitTarihiBasla" v-model="KayitTarihiBasla"></tarihcomp>
                      </v-flex>

                      <v-flex xs12 pt-2 sm6 md1>
                        <tarihcomp :etiket="$t('Finishing-Date')" :detaygizle="false"
                          :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"
                          v-bind:value="KayitTarihiBitis" v-model="KayitTarihiBitis"></tarihcomp>
                      </v-flex>
                      <v-flex xs12 pt-2 sm6 md2>
                        <genelarama
                                  :autofocuss="true"
                                  apiname="SaticiAra"
                                  :label="$t('Seller-Code')"
                                  v-model="Satici"
                                ></genelarama>
                      </v-flex>
                      <v-flex xs12 pt-2 sm6 md2>
                        <genelarama
                                  apiname="SaticiAra"
                                  :tip="12"
                                  :label="$t('Tour-Operator')"
                                  v-model="turOperatoru"
                                ></genelarama>
                      </v-flex>
                      <v-flex xs12 sm6 md1 pt-2>
                 
                    <pnrbul 
                      v-model="searchPnrNo"
                      :rules="[(v) => !!v || $t('Mandatory-section')]"
                      hide-details
                    >
                    </pnrbul>
                  
                  
                  </v-flex>
                   <v-flex xs12 sm6 md1 pt-2>
                 
                    <v-checkbox
                      v-model="searchOzet"
                      :label="this.$t('Summary-List')"
                      hide-details
                    >
                    </v-checkbox>
                  
                  
                  </v-flex>
                      <v-flex pt-2>
                        <v-layout row wrap align-center full-heigth>
                          <div v-if="load1">
                            <v-btn color="info" @click="getList()" fab small dark>
                              <v-icon>search</v-icon>
                            </v-btn>
                          </div>
                          <div v-if="progress">
                            <v-layout align-center>
                              <v-progress-circular indeterminate :width="4" color="blue"></v-progress-circular>
                            </v-layout>
                          </div>
                         
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm12 md12 pb-3>
  <v-card flat>
    <v-card-text class="pa-0">
      <div class="table-topbar pa-3">
        <div class="table-topbar-left">
          <span class="table-stat">
            Görünen Kolon:
            <strong>{{ visibleHeaders.length }}</strong>
            /
            <strong>{{ headerssatis.length }}</strong>
          </span>

          <span class="table-stat ml-3">
            Kayıt:
            <strong>{{ sortedItems.length }}</strong>
            /
            <strong>{{ itemssatis.length }}</strong>
          </span>
        </div>

        <div class="table-topbar-right">
          <v-btn small color="primary" class="mr-2" @click="columnDialog = true">
            <v-icon left small>tune</v-icon>
            Kolonlar
          </v-btn>

          <v-btn
            v-if="PB == 'TRY'"
            small
            color="success"
            @click="getListExcel"
          >
            <v-icon left small>file_download</v-icon>
            Excel
          </v-btn>
        </div>
      </div>

      <div class="dt-wrap">
        <!-- ÜST scrollbar -->
        <div class="dt-scroll-top" ref="dtScrollTop" @scroll="syncDtTop">
          <div class="dt-scroll-inner" ref="dtScrollInner"></div>
        </div>

        <!-- ALT gerçek scroll alanı -->
        <div class="modern-table-wrapper dt-scroll-bottom" ref="dtScrollBottom">
          <table class="modern-table" ref="modernTable">
            <thead>
              <draggable
                v-model="visibleHeadersProxy"
                tag="tr"
                :options="dragOptions"
                @end="onHeaderDragEnd"
              >
                <th
                  v-for="header in visibleHeadersProxy"
                  :key="header.value"
                  :style="{ width: header.width || '140px', minWidth: header.width || '140px' }"
                  :class="[
                    'modern-th',
                    'text-xs-' + (header.align || 'left'),
                    sortBy === header.value ? 'sorted-column' : ''
                  ]"
                >
                  <div class="th-inner">
                    <div class="th-left drag-handle" :title="'Taşımak için sürükle: ' + header.text">
                      <v-icon small class="drag-icon">drag_indicator</v-icon>
                      <span class="th-title">{{ header.text }}</span>
                    </div>

                    <div
                      class="th-sort"
                      @click.stop="toggleSort(header)"
                      :title="'Sırala: ' + header.text"
                    >
                      <v-icon small v-if="sortBy !== header.value">unfold_more</v-icon>
                      <v-icon small v-else-if="sortDesc">arrow_downward</v-icon>
                      <v-icon small v-else>arrow_upward</v-icon>
                    </div>
                  </div>
                </th>
              </draggable>
            </thead>

            <tbody>
              <tr
                v-for="(item, rowIndex) in pagedItems"
                :key="item.IslemRef ? item.IslemRef + '_' + rowIndex : rowIndex"
                class="modern-row"
                @click="git(item)"
              >
                <td
                  v-for="col in visibleHeaders"
                  :key="col.value"
                  :class="[
                    'modern-td',
                    'text-xs-' + (col.align || 'left')
                  ]"
                  :style="{ width: col.width || '140px', minWidth: col.width || '140px' }"
                >
                  <template v-if="col.value === 'PNR_No'">
                    <a
                      href="#"
                      @click.prevent.stop="pnrGit(item.PNR_No)"
                      class="pnr-link"
                    >
                      {{ item.PNR_No }}
                    </a>
                  </template>

                  <template v-else>
                    {{ formatCellValue(item, col) }}
                  </template>
                </td>
              </tr>

              <tr v-if="!pagedItems.length">
                <td :colspan="visibleHeaders.length || 1" class="empty-table-cell">
                  Kayıt bulunamadı
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="table-footer pa-3">
        <div class="rows-per-page-box">
          <span class="mr-2">Sayfa başına:</span>
          <v-select
            :items="[20, 50, 100]"
            v-model="rowsPerPage"
            hide-details
            dense
            solo
            flat
            style="max-width: 90px;"
          ></v-select>
        </div>

        <div class="pagination-box">
          <v-btn icon small :disabled="page <= 1" @click="prevPage">
            <v-icon>chevron_left</v-icon>
          </v-btn>

          <span class="page-text">
            {{ pageStart }}-{{ pageEnd }} / {{ sortedItems.length }}
          </span>

          <v-btn icon small :disabled="page >= totalPages" @click="nextPage">
            <v-icon>chevron_right</v-icon>
          </v-btn>
        </div>
      </div>
    </v-card-text>
  </v-card>
</v-flex>
                <yetkidialog ref="yetkidialog"></yetkidialog>

              </v-layout>
            </v-form>
          </v-container>

          <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
            :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
          </v-snackbar>

          <v-dialog v-model="dialogupdate" scrollable persistent max-width="500px">
            <v-card flat color="grey lighten-4">
              <v-card-title>{{ $t('Update') }}</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12 sm6 md12 pa-1>
                    <v-card flat class="white--text">
                      <v-card flat color="grey lighten-5">
                        <v-card-actions>
                          <v-layout row wrap>
                            <v-flex  xs11 sm11 md11>
                                <genelarama
                                  :autofocuss="true"
                                  apiname="SaticiAra"
                                  tip="2"
                                  :label="$t('Seller-Code')"
                                  v-model="UpdatePrm.SaticiKod"
                                ></genelarama>
                               
                              </v-flex>

                              <v-flex xs1 sm1 md1>
                                <v-layout
                                  row
                                  wrap
                                  fill-height
                                  align-end
                                  justify-center
                                >
                                  <minisaticieklecomp
                                    v-model="UpdatePrm.SaticiKod"
                                    :label="$t('Add-transfer-Seller')"
                                    saticiKod="2"
                                  >
                                  </minisaticieklecomp>
                                </v-layout>
                              </v-flex>
                            <!-- <v-flex  xs12 sm12 md12>
                              <v-autocomplete
                                  hide-details
                                  :items="saticiitems"
                                  :label="$t('Seller')"
                                  item-text="isim"
                                  v-model="UpdatePrm.SaticiKod"
                                  item-value="kod"
                                >
                                </v-autocomplete>
                            </v-flex> -->
                            <!-- <v-flex  xs12 sm12 md12>
                              <v-autocomplete
                                  hide-details
                                  :items="otelitems"
                                  :label="$t('Hotel')"
                                  item-text="isim"
                                  v-model="UpdatePrm.OtelKod"
                                  item-value="kod"
                                >
                                </v-autocomplete>
                            </v-flex> -->
                            <v-flex  xs11 sm11 md11>
                                <genelarama
                                  :autofocuss="true"
                                  apiname="SaticiAra"
                                  tip="1"
                                  :label="$t('Hotel')"
                                  v-model="UpdatePrm.OtelKod"
                                ></genelarama>
                               
                              </v-flex>

                              <v-flex xs1 sm1 md1>
                                <v-layout
                                  row
                                  wrap
                                  fill-height
                                  align-end
                                  justify-center
                                >
                                  <minisaticieklecomp
                                    v-model="UpdatePrm.OtelKod"
                                    :label="$t('Add-hotel-Seller')"
                                    saticiKod="1"
                                  >
                                  </minisaticieklecomp>
                                </v-layout>
                              </v-flex>
                            <v-flex xs12 sm6 md12>
                              <v-flex xs12 sm6 md12>
                            <aracalanara
                                  :saticikodu="UpdatePrm.SaticiKod"
                                  v-model="UpdatePrm.Arac"
                                >
                                </aracalanara>
                              </v-flex>
                             
                            </v-flex>
                              <v-flex  xs11 sm11 md11>
                                <genelarama
                                  :autofocuss="true"
                                  apiname="SaticiAra"
                                  tip="6"
                                  :label="$t('Guide')"
                                  v-model="UpdatePrm.Rehber"
                                ></genelarama>
                               
                              </v-flex>

                              <v-flex xs1 sm1 md1>
                                <v-layout
                                  row
                                  wrap
                                  fill-height
                                  align-end
                                  justify-center
                                >
                                  <minisaticieklecomp
                                    v-model="UpdatePrm.Rehber"
                                    :label="$t('Add-guide-Seller')"
                                    saticiKod="6"
                                  >
                                  </minisaticieklecomp>
                                </v-layout>
                              </v-flex>

                            <!-- <v-flex xs12 sm12 md12>
                              <v-autocomplete
                                  hide-details
                                  :items="rehberitems"
                                  :label="$t('Guide')"
                                  item-text="isim"
                                  v-model="UpdatePrm.Rehber"
                                  item-value="kod"
                                  
                                >
                                </v-autocomplete>
                                
                            </v-flex> -->

                           
                          <v-flex xs12 sm12 md12>
                            <v-text-field v-model="UpdatePrm.TurKodu" :label="$t('Tour-Code')"></v-text-field>
                          </v-flex>
                          

                          <tasimatipi v-model="UpdatePrm.TasimaTipi"> </tasimatipi>


                     <!--        <v-flex xs12 sm12 md12>
                              <v-select
                                  hide-details
                                  :items="turkoduitems"
                                  label="Type"
                                  item-text="Aciklama"
                                  item-value="Kod"
                                  v-model="UpdatePrm.Tip"
                                  
                                >
                                </v-select>
                          </v-flex> -->

                         
                        <!--   <v-flex xs12 sm12 md12>
                            <v-text-field v-model="UpdatePrm.Saat" :label="$t('Hour')" type="time" :rules="[v => !!v || $t('Mandatory-section')]"></v-text-field>
                          </v-flex>

                          <v-flex xs12 sm12 md12>
                            <v-text-field v-model="UpdatePrm.UcusSaat" :label="$t('Flight-Hour')" type="time" :rules="[v => !!v || $t('Mandatory-section')]"></v-text-field>
                          </v-flex>-->
                          <v-flex xs12 sm12 md12>
  <v-text-field
    v-model="UpdatePrm.UcusSaat"
    :label="$t('Flight-Time')"
    type="text"
    mask="##:##"
    placeholder="HH:mm"
    clearable
    return-masked-value
    maxlength="5"
  ></v-text-field>
</v-flex>
<v-flex xs12 sm12 md12>
  <v-text-field
    v-model="UpdatePrm.Saat"
    :label="$t('Hour')"
    type="text"
    mask="##:##"
    placeholder="HH:mm"
    clearable
    return-masked-value
    maxlength="5"
  ></v-text-field>
</v-flex>


                          
                          </v-layout>
                        </v-card-actions>
                      </v-card>
                    </v-card>
                  </v-flex>


                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="updateiptal()">{{$t("cancel_button")}}</v-btn>
                <v-btn color="blue darken-1" flat @click.native="updatekayit()">{{ $t('Apply') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>


<script>
  import auth from "../../../../api/auth";
  import tarihcomp from "../../customcomp/tarihim";
  import helpers from "@/components/app/customcomp/helpers.js";
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
  import tool from "../tools";
  import hatadialog from "@/components/app/coper/comp/hatadialog.vue";
  import anatip from "@/components/app/coper/comp/anatip.vue";
  import rez from "../rezervasyon";
  import genelarama from "@/components/app/coper/comp/genelarama.vue";
  import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue"
  import pnrbul from "@/components/app/coper/component/pnrbul.vue";
  import cariaracomp from "@/components/app/customcomp/cariaracomp"
  import tasimatipi from "@/components/app/coper/component/tasimatipi.vue";
  import aracalanara from "@/components/app/coper/component/aracalanara.vue";
   import minisaticieklecomp from "@/components/app/coper/component/minisaticieklecomp.vue";
  import draggable from "vuedraggable";
  const TABLE_SETTINGS_KEY = "transferisimlistesi_table_settings_v2";
  export default {
    data() {
      return {
        headerssatis: [],
columnDialog: false,

sortBy: "",
sortDesc: false,
page: 1,
rowsPerPage: 20,

dragOptions: {
  animation: 150,
  handle: ".drag-handle",
  ghostClass: "drag-ghost",
  chosenClass: "drag-chosen",
  dragClass: "drag-dragging"
},
        tableWidth: 2000,
      searchOzet:false,
        itemssatis:[],
        saticiitems:[],
        otelitems:[],
        aracitems:[],
        rehberitems:[],
      
        turkoduitems: [],
        menu1: false,
        UpdatePrm:{
       IslemRef: 0,
  UcusSaat: null,
  Saat: null,
  Rehber: "",
  SaticiKod: "",
  OtelKod: "",
  Arac: "",
  Tip: "",
  TasimaTipi: "",
  
  TurKodu:"",

        },
        PB:'TRY',
        Satici:null,
        tumsirketler:false,
        

        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0
        },
       
        search: "",
      // "SirketNo": 1,
      // "Tip": null,
      // "TasimaTipi": null,
      // "OdaNo": null,
      // "Acente": null,
     
    
    
     
    
     
     

      
     
     

      

  //       headerssatis: [

  //        {
  //           text: this.$t('PNR_No'),
  //           value: "PNR_No",
  //           width: "5%",
  //           align: "left"
  //         },
  //          {
  //           text: 'RezzKod',
  //           value: "RezzKod",
  //           width: "5%",
  //           align: "left"
  //         },
  //         {
  //           text: this.$t('Tour-Code'),
  //           value: "TurKodu",
  //           width: "5%",
  //           align: "left"
  //         },

  // {
  //           text: this.$t('Period-v2') + "1",
  //           value: "Donem1",
  //           width: "5%",
  //           align: "left"
  //         },
 
  //          {
  //           text: 'UcusNo',
  //           value: "UcusNo",
  //           width: "5%",
  //           align: "left"
  //         },
  //           {
  //           text: this.$t('Flight-Time'),
  //           value: "UcusSaatStr",
  //           width: "5%",
  //           align: "left"
  //         },
  //          {
  //           text: this.$t('Hour'),
  //           value: "SaatStr",
  //           width: "5%",
  //           align: "left"
  //         },
  //           {
  //           text: 'ADT',
  //           value: "ADT",
  //           width: "5%",
  //           align: "left"
  //         },
  //            {
  //           text: 'Nerden',
  //           value: "Nerden",
  //           width: "5%",
  //           align: "left"
  //         },
  //         {
  //           text: 'Nereye',
  //           value: "Nereye",
  //           width: "5%",
  //           align: "left"
  //         },
  //          {
  //           text: 'Transfer',
  //           value: "Arac",
  //           width: "5%",
  //           align: "left"
  //         },
  //          {
  //           text: 'Rehber',
  //           value: "Rehber",
  //           width: "5%",
  //           align: "left"
  //         },
  //         {
  //           text: this.$t('Process-Ref'),
  //           value: "IslemRef",
  //           width: "10%",
  //           align: "left"
  //         },
  //          {
  //           text: this.$t('Pax'),
  //           value: "Pax",
  //           width: "5%",
  //           align: "left"
  //         },
  //        {
  //           text: 'Isim',
  //           value: "Isim",
  //           width: "5%",
  //           align: "left"
  //         },
  //           {
  //           text: 'Acente Ad',
  //           value: "AcenteAd",
  //           width: "5%",
  //           align: "left"
  //         },
        
       
  //         {
  //           text: this.$t('Hotel-Code'),
  //           value: "OtelKod",
  //           width: "5%",
  //           align: "left"
  //         },
         
  //         {
  //           text: this.$t('Hotel-Name'),
  //           value: "OtelAd",
  //           width: "10%",
  //           align: "left"
  //         },
  //          {
  //           text: 'Aciklama',
  //           value: "Aciklama",
  //           width: "5%",
  //           align: "left"
  //         },
         
           
         
          
  //         {
  //           text: 'PINCode',
  //           value: "PINCode",
  //           width: "5%",
  //           align: "left"
  //         },
          
         
  //         {
  //           text: 'YetiskinPax',
  //           value: "YetiskinPax",
  //           width: "5%",
  //           align: "left"
  //         },
  //         {
  //           text: 'Cocuk1Pax',
  //           value: "Cocuk1Pax",
  //           width: "5%",
  //           align: "left"
  //         },
  //         {
  //           text: 'Cocuk2Pax',
  //           value: "Cocuk2Pax",
  //           width: "5%",
  //           align: "left"
  //         },
         
        
  //         {
  //           text: 'SaticiKod',
  //           value: "SaticiKod",
  //           width: "5%",
  //           align: "left"
  //         },
         
  //         {
  //           text: 'TurOperatoru',
  //           value: "TurOperatoru",
  //           width: "5%",
  //           align: "left"
  //         },
         
  //          {
  //           text: this.$t('Ref'),
  //           value: "Ref",
  //           width: "5%",
  //           align: "left"
  //         },
         
        
         
        
  //         {
  //           text: 'SoforTahsilatTutar',
  //           value: "SoforTahsilatTutar",
  //           width: "5%",
  //           align: "left"
  //         },
  //         {
  //           text: 'strTransferDurumu',
  //           value: "strTransferDurumu",
  //           width: "5%",
  //           align: "left"
  //         },
  //         {
  //           text: 'AracRehber',
  //           value: "AracRehber",
  //           width: "5%",
  //           align: "left"
  //         },
  //         {
  //           text: 'Cari_Kod',
  //           value: "Cari_Kod",
  //           width: "5%",
  //           align: "left"
  //         },
         
       
         
         
         
         
         
         
        
         
        
  //       ],
       
       
        searchPnrNo:null,
        turOperatoru:null,
        KayitTarihiBasla: null,
        KayitTarihiBitis: null,
        SaticiKodu:null,
      
        valid: true,
      
        loading: false,
        items: [],
        load: false,
        load1: true,
        search3: "",
        renk1: "info",
        dialogupdate: false,
        searchcari: "",
        progress: false,
        tooltip: false,
        el: null,
        butondurum: true,
        snackbar: false,
        y: "top",
        x: "right",
        mode: "",
        timeout: 6000,
        text1: "",
        dictionary: {
          custom: {
            tarihsec: {
              required: () => this.$t('Please-select-a-date')
            },
            tarihsec1: {
              required: () => this.$t('Please-select-a-date')
            }
          }
        }
      };
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path;
      });
    },
    beforeMount: beforeMount,
computed: {
  visibleHeaders() {
    return this.headerssatis.filter(h => h.visible);
  },

  visibleHeadersProxy: {
    get() {
      return this.visibleHeaders;
    },
    set(newVisibleOrderedList) {
      const hiddenHeaders = this.headerssatis.filter(h => !h.visible);
      this.headerssatis = newVisibleOrderedList.concat(hiddenHeaders);
      this.saveTableSettings();
      this.updateDtScrollWidth();
    }
  },

  sortedItems() {
    const items = Array.isArray(this.itemssatis) ? this.itemssatis.slice() : [];

    if (!this.sortBy) {
      return items;
    }

    const sortKey = this.sortBy;
    const desc = this.sortDesc;

    items.sort((a, b) => {
      let valA = this.getSortableValue(a, sortKey);
      let valB = this.getSortableValue(b, sortKey);

      const aIsNumber = typeof valA === "number" && !isNaN(valA);
      const bIsNumber = typeof valB === "number" && !isNaN(valB);

      if (aIsNumber && bIsNumber) {
        return desc ? valB - valA : valA - valB;
      }

      valA = safeLower(valA);
      valB = safeLower(valB);

      if (valA < valB) return desc ? 1 : -1;
      if (valA > valB) return desc ? -1 : 1;
      return 0;
    });

    return items;
  },

  totalPages() {
    if (!this.sortedItems.length) return 1;
    return Math.max(1, Math.ceil(this.sortedItems.length / this.rowsPerPage));
  },

  pagedItems() {
    const start = (this.page - 1) * this.rowsPerPage;
    const end = start + this.rowsPerPage;
    return this.sortedItems.slice(start, end);
  },

  pageStart() {
    if (!this.sortedItems.length) return 0;
    return (this.page - 1) * this.rowsPerPage + 1;
  },

  pageEnd() {
    if (!this.sortedItems.length) return 0;
    return Math.min(this.page * this.rowsPerPage, this.sortedItems.length);
  }
},
    mounted() {
this.headerssatis = createHeaders(this);
this.loadTableSettings();
      this.getOtelItems();
      this.getSaticiItems();    
 this.getaracItems(); 
 this.getrehberItems();

      
      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)
      var credentials = JSON.parse(
       window.localStorage.getItem("credentials")
    );
    this.PB=credentials.ParaBirimi;
    this.$validator.localize("en", this.dictionary);
           
            var credentials = JSON.parse(window.localStorage.getItem("credentials"));

            var params = {
              CompanyCode: credentials.SirketKodu
            };

            this.$http
              .post(auth.API_URL + "api/currency/List", params, {
                headers: {
                  Authorization: "Bearer " + auth.getAuthHeader()
                }
              })
              .then(
                response => {
                  this.doviztipi = response.body;
                },
                response => {
                  if (response.status === 0) {
                    this.text1 = "Service Unavailable-Döviz";
                    this.snackbar = true;
                  } else {
                    this.text1 = "Service Unavailable-Döviz";
                    this.snackbar = true;
                  }
                }
              );

           this.updateDtScrollWidth()
window.addEventListener('resize', this.updateDtScrollWidth)
    },

beforeDestroy() {
  window.removeEventListener('resize', this.updateDtScrollWidth)
},



    filters: {
      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },

      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }
    },

    components: {
      tarihcomp: tarihcomp,
      yetkidialog,
      hatadialog,
      anatip,
      genelarama,
      referansmerkezicomp,
      pnrbul,
      cariaracomp,
      tasimatipi,
      aracalanara,
      minisaticieklecomp,
      draggable
    },
   watch: {
  itemssatis() {
    this.page = 1;
    this.updateDtScrollWidth();
  },

  headerssatis: {
    deep: true,
    handler() {
      this.saveTableSettings();
      this.updateDtScrollWidth();
    }
  },

  rowsPerPage() {
    this.page = 1;
    this.saveTableSettings();
  }
},
    methods: {
      formatCellValue(item, col) {
  if (!item || !col) return "";

  if (col.value === "Donem1") {
    return this.formatDate(item.Donem1);
  }

  const value = item[col.value];
  if (value === null || value === undefined) return "";

  return value;
},

getSortableValue(item, key) {
  if (!item) return "";

  if (key === "Donem1") {
    const rawDate = item[key];
    if (!rawDate) return "";
    const time = new Date(rawDate).getTime();
    return isNaN(time) ? this.formatDate(rawDate) : time;
  }

  const value = item[key];

  if (value === null || value === undefined) return "";

  if (typeof value === "number") return value;

  if (!isNaN(Number(value)) && value !== "") {
    return Number(value);
  }

  return String(value);
},

toggleSort(header) {
  if (!header || !header.value) return;

  if (this.sortBy !== header.value) {
    this.sortBy = header.value;
    this.sortDesc = false;
  } else if (this.sortBy === header.value && this.sortDesc === false) {
    this.sortDesc = true;
  } else {
    this.sortBy = "";
    this.sortDesc = false;
  }

  this.page = 1;
  this.saveTableSettings();
},

onHeaderDragEnd() {
  this.saveTableSettings();
  this.updateDtScrollWidth();
},

prevPage() {
  if (this.page > 1) {
    this.page -= 1;
  }
},

nextPage() {
  if (this.page < this.totalPages) {
    this.page += 1;
  }
},

resetColumns() {
  this.headerssatis = createHeaders(this);
  this.sortBy = "";
  this.sortDesc = false;
  this.page = 1;
  this.saveTableSettings();
  this.$nextTick(() => {
    this.updateDtScrollWidth();
  });
},

saveTableSettings() {
  try {
    const payload = {
      headers: this.headerssatis.map(h => ({
        value: h.value,
        visible: h.visible
      })),
      sortBy: this.sortBy,
      sortDesc: this.sortDesc,
      rowsPerPage: this.rowsPerPage
    };

    window.localStorage.setItem(TABLE_SETTINGS_KEY, JSON.stringify(payload));
  } catch (e) {
    return null;
  }
},

loadTableSettings() {
  try {
    const raw = window.localStorage.getItem(TABLE_SETTINGS_KEY);
    if (!raw) return;

    const parsed = JSON.parse(raw);
    if (!parsed || !Array.isArray(parsed.headers)) return;

    const defaults = createHeaders(this);
    const defaultMap = {};

    defaults.forEach(h => {
      defaultMap[h.value] = h;
    });

    const rebuilt = [];

    parsed.headers.forEach(saved => {
      if (defaultMap[saved.value]) {
        rebuilt.push({
          ...defaultMap[saved.value],
          visible: typeof saved.visible === "boolean" ? saved.visible : true
        });
      }
    });

    defaults.forEach(h => {
      const exists = rebuilt.some(x => x.value === h.value);
      if (!exists) {
        rebuilt.push(h);
      }
    });

    this.headerssatis = rebuilt;

    if (parsed.sortBy) {
      this.sortBy = parsed.sortBy;
    }

    if (typeof parsed.sortDesc === "boolean") {
      this.sortDesc = parsed.sortDesc;
    }

    if (parsed.rowsPerPage) {
      this.rowsPerPage = parsed.rowsPerPage;
    }
  } catch (e) {
    return null;
  }
},

escapeCsvValue(value) {
  if (value === null || value === undefined) return '""';
  return `"${String(value).replace(/"/g, '""')}"`;
},
  getBottomScrollerEl() {
  return this.$refs.dtScrollBottom || null;
},

syncDtTop(e) {
  const bottom = this.getBottomScrollerEl();
  if (bottom) bottom.scrollLeft = e.target.scrollLeft;
},

  syncDtBottom(e) {
    // dtScrollBottom değil, gerçek scroller’dan okuyup top’a basıyoruz
    const bottom = e.target
    if (this.$refs.dtScrollTop) this.$refs.dtScrollTop.scrollLeft = bottom.scrollLeft
  },

 bindBottomScrollListener() {
  this.$nextTick(() => {
    const bottom = this.getBottomScrollerEl();
    if (!bottom) return;

    if (this._onBottomScroll) {
      bottom.removeEventListener("scroll", this._onBottomScroll);
    }

    this._onBottomScroll = ev => {
      if (this.$refs.dtScrollTop) {
        this.$refs.dtScrollTop.scrollLeft = ev.target.scrollLeft;
      }
    };

    bottom.addEventListener("scroll", this._onBottomScroll, { passive: true });
  });
},

 updateDtScrollWidth() {
  this.$nextTick(() => {
    const bottom = this.getBottomScrollerEl();
    const table = this.$refs.modernTable;

    const w =
      (table && table.scrollWidth) ||
      (bottom && bottom.scrollWidth) ||
      0;

    if (this.$refs.dtScrollInner && w) {
      this.$refs.dtScrollInner.style.width = w + "px";
    }

    this.bindBottomScrollListener();
  });
},
      pnrGit(val){
  let url = "#/coper/rezervasyon/index/id?islem=get&PNR_No=" + val;
        window.open(url, "_target");
      },
       formatDate(dateStr) {
    if (!dateStr) return ''

    const date = new Date(dateStr)

    const day = ('0' + date.getDate()).slice(-2)
    const month = ('0' + (date.getMonth() + 1)).slice(-2)
    const year = date.getFullYear()

    return `${day}.${month}.${year}`
  },

      getaracItems()
    {
      
      var prm = {
        id: "",
        kod: "",
        aciklama: "",
        tip: 2,
        YurtIcDis:0,
      };
      tool.http_post(this, 'SaticiAra', prm).then(
        response => {
         this.aracitems=response.body;
        },
        response => {
          // this.status = tool.responseToStatus(response);
        }
      );
    },
    getrehberItems()
    {
      
      var prm = {
        id: "",
        kod: "",
        aciklama: "",
        tip: 6,
        YurtIcDis:0,
      };
      tool.http_post(this, 'SaticiAra', prm).then(
        response => {
         this.rehberitems=response.body;
        },
        response => {
          // this.status = tool.responseToStatus(response);
        }
      );
    },
    getOtelItems()
    {
      
      var prm = {
        id: "",
        kod: "",
        aciklama: "",
        tip: 1,
        YurtIcDis:0,
      };
      tool.http_post(this, 'SaticiAra', prm).then(
        response => {
         this.otelitems=response.body;
        },
        response => {
          // this.status = tool.responseToStatus(response);
        }
      );
    },
      getSaticiItems()
    {
      
      var prm = {
        id: "",
        kod: "",
        aciklama: "",
         tip: 2,
        YurtIcDis:0,
      };
      tool.http_post(this, 'SaticiAra', prm).then(
        response => {
         this.saticiitems=response.body;
        },
        response => {
          // this.status = tool.responseToStatus(response);
        }
      );
    },
      turkodugetir(SaticiKod) {
      var params = {
        SaticiKodu: SaticiKod,
      };

      tool.http_post(this, "AcenteTurlar", params).then(
        (response) => {
          this.turkoduitems = response.body.data;
        },
        (response) => {
          this.text1 = this.$t('Location-could-not-found-error-occured');
          this.snackbar = true;
        }
      );
    },
updateiptal()
{
this.dialogupdate=false;
},
updatekayit()
{
  
 
  

 if (this.UpdatePrm.Tip=="")
 {
  this.UpdatePrm.Tip=null;
 }
 if (this.UpdatePrm.TasimaTipi=="")
 {
  this.UpdatePrm.TasimaTipi=null;
 }

 if (this.UpdatePrm.OtelKod=="")
 {
  this.UpdatePrm.OtelKod=null;
 }
 if (this.UpdatePrm.Arac=="")
 {
  this.UpdatePrm.Arac=null;
 }
 if (this.UpdatePrm.Rehber=="")
 {
  this.UpdatePrm.Rehber=null;
 }
 if (this.UpdatePrm.Saat=="")
 {
  this.UpdatePrm.Saat=null;
 }
 if (this.UpdatePrm.UcusSaat=="")
 {
  this.UpdatePrm.UcusSaat=null;
 }
 if (this.UpdatePrm.Rehber && this.UpdatePrm.Rehber.kod && this.UpdatePrm.Rehber.kod!=null){
  this.UpdatePrm.Rehber=this.UpdatePrm.Rehber.kod;
 }else{
  this.UpdatePrm.Rehber="";
 }
  if (this.UpdatePrm.OtelKod && this.UpdatePrm.OtelKod.kod && this.UpdatePrm.OtelKod.kod!=null){
  this.UpdatePrm.OtelKod=this.UpdatePrm.OtelKod.kod;
 }else{
  this.UpdatePrm.OtelKod="";
 }
  if (this.UpdatePrm.SaticiKod && this.UpdatePrm.SaticiKod.kod && this.UpdatePrm.SaticiKod.kod!=null){
  this.UpdatePrm.SaticiKod=this.UpdatePrm.SaticiKod.kod;
 }else{
  this.UpdatePrm.SaticiKod="";
 }
console.log(this.UpdatePrm.Rehber);
      tool.http_post(this, "TransferIsimListesiUpdateControl", this.UpdatePrm).then(
        (response) => {
            
          this.dialogupdate=false;
          this.getList();
         
          if (response.body.status) {
          } else {
               this.text1 = response.body.ErrorList[0];
                this.snackbar = true;
            }
        },
        (response) => {
          this.text1 = this.$t('Location-could-not-found-error-occured');
          this.snackbar = true;
        }
      );


},
      HataYonetimi(response, request, baslik) {
        if (response.status === 500) {
          //Internal Server Error
          this.$refs.hatadialog.open(response, request, baslik);
        } else {
          this.text1 = "Service Unavailable -" + baslik;
          this.snackbar = true;
        }
      },

      git(val) {
        let rehberprm=null;
         if (val.Rehber){
          rehberprm ={kod:val.Rehber, id: "0", isim: val.RehberAd, isimAra: "",YurtIci_YurtDisi:"",CariKod:"",KDV:0};
         }
        let otelprm=null;
         if (val.OtelKod){
          otelprm ={kod:val.OtelKod, id: "0", isim: val.OtelAd, isimAra: "",YurtIci_YurtDisi:"",CariKod:"",KDV:0};
         }
   let saticiprm=null;
         if (val.SaticiKod){
          saticiprm ={kod:val.SaticiKod, id: "0", isim: val.SaticiAd, isimAra: "",YurtIci_YurtDisi:"",CariKod:"",KDV:0};
         }
  
 this.UpdatePrm.UcusSaat=val.UcusSaatStr;
 this.UpdatePrm.IslemRef=val.IslemRef;
 this.UpdatePrm.Saat=val.SaatStr;
 this.UpdatePrm.Tip=val.Tip;
 this.UpdatePrm.TasimaTipi=val.TasimaTipi;
 this.UpdatePrm.TurKodu=val.TurKodu;
 this.UpdatePrm.OtelKod=otelprm;
 this.UpdatePrm.Arac=val.Arac;
 this.UpdatePrm.Rehber=rehberprm;
 this.UpdatePrm.SaticiKod=saticiprm;

        this.turkodugetir(val.SaticiKod);
        this.dialogupdate = true;
        
      },
      getList: getList,
      getListExcel,
      
    }
  };


  

  function getList() {
    




    var saticiprm=null;
      if (this.Satici!=null)
      {
         saticiprm=this.Satici.kod;
      }
      var operatorprm=null;
      if (this.turOperatoru!=null)
      {
        operatorprm=this.turOperatoru.kod;
      }
    let params = {
        Tarih1: this.KayitTarihiBasla,
        Tarih2: this.KayitTarihiBitis,
        SaticiKod: saticiprm,
        OperatorKod: operatorprm,
        PNR_No: this.searchPnrNo,
        Ozet:this.searchOzet
      };
      


      this.progress = true;
      this.load1 = false;
       
 
        tool.http_post(this, "TransferIsimListesi", params).then(
          response => {
            // if (response.body.Status == true) {
            //   this.itemssatis = response.body.data;
            //   this.progress = false;
            //   this.load1 = true;
            // } else {
            //   this.text1 = response.body.ErrorList[0];
            //   this.snackbar = true;
            //   this.progress = false;
            //   this.load1 = true;
            // }

            if (response.body.Status == true) {
            console.log("TransferIsimListesi response :");
            console.log(response.body);
            this.itemssatis = response.body.data;
            this.updateDtScrollWidth()
            this.progress = false;
            this.load1 = true;
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
            this.progress = false;
            this.load1 = true;
          }


          },
          response => {
            this.HataYonetimi(response, params, 'Günlük Tur Listesi Getirilemedi');
            this.progress = false;
            this.load1 = true;
          }
        );
    
  }
  function TransferIsimListesiUpdateControl() {
//Örnek Request
let params={
  "IslemRef": 26070,
  "UcusSaat": "2025-03-04T10:04:54.2891435+03:00",
  "Saat": null,
  "Rehber": "",
  "SaticiKod": "TRANSFER1",
  "OtelKod": "",
  "Arac": "ana2",
  "Tip": "BBBB",
}
tool.http_post(this, 'TransferIsimListesiUpdateControl',params).then(
response => {
if (response.body.Status == true)
{
console.log('TransferIsimListesiUpdateControl response :');
console.log(response.body);
}
else
{
this.text1 = response.body.ErrorList[0]
  this.snackbar = true
}
},
response => {
this.text1 = 'Hata Oluştu, tekrar deneyiniz'
this.snackbar = true
}
);
}
function createHeaders(vm) {
  return [
    { text: vm.$t("PNR_No"), value: "PNR_No", width: "140px", align: "left", visible: true },
    { text: "RezzKod", value: "RezzKod", width: "140px", align: "left", visible: true },
    { text: vm.$t("Tour-Code"), value: "TurKodu", width: "160px", align: "left", visible: true },
    { text: vm.$t("Period-v2") + "1", value: "Donem1", width: "140px", align: "left", visible: true },
    { text: "UcusNo", value: "UcusNo", width: "120px", align: "left", visible: true },
    { text: vm.$t("Flight-Time"), value: "UcusSaatStr", width: "130px", align: "left", visible: true },
    { text: vm.$t("Hour"), value: "SaatStr", width: "120px", align: "left", visible: true },
    { text: "ADT", value: "ADT", width: "100px", align: "left", visible: true },
    { text: "Nerden", value: "Nerden", width: "150px", align: "left", visible: true },
    { text: "Nereye", value: "Nereye", width: "150px", align: "left", visible: true },
    { text: "Transfer", value: "Arac", width: "140px", align: "left", visible: true },
    { text: "Rehber", value: "Rehber", width: "140px", align: "left", visible: true },
    { text: vm.$t("Process-Ref"), value: "IslemRef", width: "130px", align: "left", visible: true },
    { text: vm.$t("Pax"), value: "Pax", width: "90px", align: "left", visible: true },
    { text: "Isim", value: "Isim", width: "180px", align: "left", visible: true },
    { text: "Acente Ad", value: "AcenteAd", width: "180px", align: "left", visible: true },
    { text: vm.$t("Hotel-Code"), value: "OtelKod", width: "130px", align: "left", visible: true },
    { text: vm.$t("Hotel-Name"), value: "OtelAd", width: "180px", align: "left", visible: true },
    { text: "Aciklama", value: "Aciklama", width: "180px", align: "left", visible: true },
    { text: "PINCode", value: "PINCode", width: "130px", align: "left", visible: true },
    { text: "YetiskinPax", value: "YetiskinPax", width: "120px", align: "left", visible: true },
    { text: "Cocuk1Pax", value: "Cocuk1Pax", width: "120px", align: "left", visible: true },
    { text: "Cocuk2Pax", value: "Cocuk2Pax", width: "120px", align: "left", visible: true },
    { text: "SaticiKod", value: "SaticiKod", width: "140px", align: "left", visible: true },
    { text: "TurOperatoru", value: "TurOperatoru", width: "160px", align: "left", visible: true },
    { text: vm.$t("Ref"), value: "Ref", width: "120px", align: "left", visible: true },
    { text: "SoforTahsilatTutar", value: "SoforTahsilatTutar", width: "170px", align: "left", visible: true },
    { text: "strTransferDurumu", value: "strTransferDurumu", width: "170px", align: "left", visible: true },
    { text: "AracRehber", value: "AracRehber", width: "160px", align: "left", visible: true },
    { text: "Cari_Kod", value: "Cari_Kod", width: "130px", align: "left", visible: true }
  ];
}

function safeLower(value) {
  if (value === null || value === undefined) return "";
  return String(value).toLowerCase();
}
  // function getListExcel() {
  //     var saticiprm=null;
  //     if (this.Satici!=null)
  //     {
  //        saticiprm=this.Satici.kod;
  //     }
  //     var operatorprm=null;
  //     if (this.turOperatoru!=null)
  //     {
  //       operatorprm=this.turOperatoru.kod;
  //     }
  //   let params = {
  //       Tarih1: this.KayitTarihiBasla,
  //       Tarih2: this.KayitTarihiBitis,
  //       SaticiKod: saticiprm,
  //       OperatorKod: operatorprm,
  //       PNR_No: this.searchPnrNo,
  //       Ozet:this.searchOzet
  //     };

  //     tool.api_post_FileDownload(this, "Coper/ExcelTransferIsimListesi", params).then(
  //       (response) => {
  //         tool.CreateDownloadLink(response, "ExcelTransferIsimListesi.xlsx");
  //       },
  //       (response) => {
  //       }
  //     );

     
  // }
function getListExcel() {
  try {
    const headers = this.visibleHeaders;
    const rows = this.sortedItems;

    if (!headers.length) {
      this.text1 = "İndirilecek görünür kolon yok";
      this.snackbar = true;
      return;
    }

    const csvRows = [];

    csvRows.push(headers.map(h => this.escapeCsvValue(h.text)).join(";"));

    rows.forEach(row => {
      const line = headers.map(h => {
        return this.escapeCsvValue(this.formatCellValue(row, h));
      });
      csvRows.push(line.join(";"));
    });

    const csvContent = "\uFEFF" + csvRows.join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", "ExcelTransferIsimListesi.csv");
    link.style.visibility = "hidden";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (e) {
    this.text1 = "Excel indirme sırasında hata oluştu";
    this.snackbar = true;
  }
}
  function beforeMount() {}
</script>
<style scoped>
.dt-wrap {
  width: 100%;
}

.dt-scroll-top {
  overflow-x: auto;
  overflow-y: hidden;
  height: 16px;
}

.dt-scroll-inner {
  height: 1px;
}

.dt-scroll-bottom {
  overflow-x: auto;
  overflow-y: hidden;
}

.table-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  border-bottom: 1px solid #eceff1;
  background: #fafbfc;
}

.table-topbar-left,
.table-topbar-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.table-stat {
  font-size: 13px;
  color: #546e7a;
}

.modern-table-wrapper {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  background: #fff;
}

.modern-table {
  width: 100%;
  min-width: max-content;
  border-collapse: separate;
  border-spacing: 0;
  table-layout: fixed;
  background: #fff;
}

.modern-table thead {
  background: #f8fafc;
}

.modern-th {
  position: sticky;
  top: 0;
  z-index: 2;
  padding: 0;
  border-bottom: 1px solid #dfe6eb;
  background: #f8fafc;
  color: #37474f;
  font-weight: 600;
  font-size: 13px;
  user-select: none;
  vertical-align: middle;
}

.th-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-height: 54px;
  padding: 0 12px;
}

.th-left {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  flex: 1;
}

.th-title {
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.th-sort {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  min-width: 28px;
  height: 28px;
  border-radius: 6px;
  cursor: pointer;
  color: #607d8b;
  transition: background 0.15s ease, color 0.15s ease;
}

.th-sort:hover {
  background: rgba(25, 118, 210, 0.08);
  color: #1976d2;
}

.drag-handle {
  cursor: grab;
}

.drag-handle:active {
  cursor: grabbing;
}

.drag-icon {
  color: #90a4ae;
}

.sorted-column {
  background: #eef5ff;
  color: #1565c0;
}

.modern-row {
  transition: background 0.12s ease;
}

.modern-row:hover {
  background: #f7fbff;
}

.modern-td {
  padding: 12px;
  border-bottom: 1px solid #edf1f4;
  color: #263238;
  font-size: 13px;
  vertical-align: middle;
  background: #fff;
  word-break: break-word;
}

.pnr-link {
  color: #1976d2;
  text-decoration: none;
  font-weight: 500;
}

.pnr-link:hover {
  text-decoration: underline;
}

.empty-table-cell {
  padding: 24px 12px;
  text-align: center;
  color: #78909c;
  font-size: 14px;
  background: #fff;
}

.table-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  border-top: 1px solid #eceff1;
  background: #fafbfc;
}

.rows-per-page-box,
.pagination-box {
  display: flex;
  align-items: center;
  gap: 10px;
}

.page-text {
  font-size: 13px;
  color: #546e7a;
  min-width: 95px;
  text-align: center;
}

.column-manager-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 10px 4px;
  border-bottom: 1px solid #edf1f4;
}

.column-manager-left {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.column-manager-right {
  color: #78909c;
  font-size: 12px;
  white-space: nowrap;
}

.column-manager-title {
  color: #263238;
  font-size: 14px;
  font-weight: 500;
}

.column-manager-key {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 12px;
  background: #f1f5f9;
}

.column-drag-handle {
  cursor: grab;
  color: #90a4ae;
}

.column-drag-handle:active {
  cursor: grabbing;
}

.drag-ghost {
  opacity: 0.4;
}

.drag-chosen {
  background: #eef5ff !important;
}

.drag-dragging {
  background: #fff !important;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.12);
}

.v-toolbar .v-btn {
  text-transform: none;
}

@media (max-width: 960px) {
  .table-topbar,
  .table-footer {
    flex-direction: column;
    align-items: stretch;
  }

  .table-topbar-left,
  .table-topbar-right,
  .rows-per-page-box,
  .pagination-box {
    justify-content: space-between;
  }

  .th-inner {
    min-height: 48px;
    padding: 0 10px;
  }

  .modern-td {
    padding: 10px;
  }
}
</style>